import * as React from 'react';
import type { SendingStatus } from '../types';

/**
 * Per-institution send status for the shared send step.
 *
 * This hook once also exposed a `simulateSend(id)` that slept for
 * `SENDING_DELAY` and then reported success on `Math.random() > 1 - SUCCESS_RATE`
 * (a 90% coin flip). It was NOT dead code: `useSendStep` called it whenever no
 * `onSend` handler was supplied, on a send step the live collection-request and
 * notification workflows both render — so an omitted prop was all that stood
 * between a solicitor and a "sent" tick for correspondence that never left the
 * building (VALE-546). It is gone, `onSend` is now a required prop, and a
 * handler that is missing at runtime fails visibly instead. Never reintroduce a
 * fabricated outcome on a surface that reports on real correspondence.
 */
export const useSendingStatus = () => {
  const [sendingStatus, setSendingStatus] = React.useState<
    Record<string, SendingStatus>
  >({});
  const [isSendingAll, setIsSendingAll] = React.useState(false);

  const updateStatus = React.useCallback(
    (id: string, status: SendingStatus) => {
      setSendingStatus((prev) => ({ ...prev, [id]: status }));
    },
    []
  );

  return {
    sendingStatus,
    isSendingAll,
    setIsSendingAll,
    updateStatus
  };
};
